import { clearConversation } from 'actions/workflows-v2/workflowsV2';
import { isAttemptedToFetchRedactedConversationError } from 'api/types';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import { selectError } from 'reducers/workflows';

const useHandleAttemptedToFetchRedactedConversationError = () => {
  const dispatch = useAppDispatch();
  const error = useAppSelector(selectError);

  useEffect(() => {
    if (isAttemptedToFetchRedactedConversationError(error)) {
      dispatch(
        clearConversation({
          reason: 'redacted_conversation',
        }),
      );
    }
  }, [dispatch, error]);
};

export default useHandleAttemptedToFetchRedactedConversationError;
